// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"8ef9859f","513":"73d36065","703":"665144b9"}[chunkId] + ".chunk.js";
};